/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.circle-user\":\"Ympyrä, jonka sisällä ihmishahmo\"}");